import { Stack, Typography } from "@mui/material";
import styles from "./StudentCards.module.css";

function Card({ name }: { name: string }) {
	return (
		<div className={styles.card}>
			<Stack direction="column" gap="1px">
				<Typography className={styles.name}>{name}</Typography>
			</Stack>
		</div>
	);
}

/**
 * `subject` is the student who owns the session being viewed; `partner` is the other student
 * they were flagged for collaborating with. Naming mirrors the backend's collaboration event
 * details (see collaboration-detection.ts) so it's unambiguous which side is which.
 */
export default function StudentCards({
	subjectStudentName,
	partnerStudentName,
}: {
	subjectStudentName: string;
	partnerStudentName: string;
}) {
	return (
		<Stack direction="row" gap="12px" alignItems="center">
			<Card name={subjectStudentName} />
			<Typography className={styles.vsText}>&</Typography>
			<Card name={partnerStudentName} />
		</Stack>
	);
}
